import { isEmail, useForm, UseFormReturnType } from '@mantine/form';
import {useLocation} from "react-router-dom";

type FormValues = {
  email: string;
};

type UseLogin = () => {
  onSubmit: () => void;
  form: UseFormReturnType<FormValues>;
}

const useLogin: UseLogin = () => {
  const location = useLocation();
  // Strip leading slash so the value can be appended as a `redirect_to` query param.
  // Treat `/login` (and empty) as "no useful referrer" and default to `dashboard` —
  // otherwise an auth bounce that captured `/login` as the referrer would round-trip
  // the user right back to the login page after a successful sign-in.
  const rawReferrer = (location.state?.referrer || '').replace(/^\//, '');
  const referrerUrl = rawReferrer && rawReferrer !== 'login' ? rawReferrer : 'dashboard';

  const form = useForm<FormValues>({
    initialValues: {
      email: '',
    },
    validate: {
      email: isEmail('Please provide a valid email'),
    },
  });

  const onSubmit = form.onSubmit(({ email }) => {
    const returnToUrl = new URL(window.location.href.replace('login', 'auth-complete'));

    if (referrerUrl) {
      returnToUrl.searchParams.set('redirect_to', encodeURIComponent(referrerUrl));
    }

    const url = new URL(`${import.meta.env.VITE_MY_FOODA_APP_URL}/auth/fooda/start`);

    url.searchParams.append('email', email);
    url.searchParams.append('fooda_property', '1');
    url.searchParams.append('embedding', '1');
    url.searchParams.append('return_to', returnToUrl.toString());
    url.searchParams.append('reset_password_url', window.location.href.replace('login', 'forgot_password/email'));

    window.location.href = url.href;
  });

  return {
    onSubmit,
    form,
  };
};

export default useLogin;
